import { Component } from '@angular/core';
import { DataService } from '../../core/services/data/data.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgClass],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
}) 
export class NavbarComponent { 

  constructor( 
    private DataService : DataService ,
    private auth : AuthService 
  ) {}

  isArabic = false ;

  socials : any ;

  isLogin = false ;

  changeLangBtn() {
    if (this.DataService.isArabic) {
      this.DataService.isArabic = false;
      this.isArabic = false;
      localStorage.setItem('hurghadaradioLang', 'en');
    } else {
      this.DataService.isArabic = true;
      this.isArabic = true;
      localStorage.setItem('hurghadaradioLang', 'ar');
    }
  }

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
  }

  scr() {
    if (window.scrollY >= 150) {
      document.querySelector('nav')?.classList.add('changeNavColors') ;
    } else {
      document.querySelector('nav')?.classList.remove('changeNavColors') ;
    } 
  }

  ngOnInit(): void { 

    this.changeLang() ;

    this.socials = this.DataService.socials ;

    this.checkLoginStatues();
  }

  checkLoginStatues () {
    this.auth.currentUser$.subscribe((user) => {
      if (user) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    });
  }

  logout() {
    const confirmLogout = confirm("هل أنت متأكد أنك تريد تسجيل الخروج؟");
  
    if (confirmLogout) {
      this.auth.logout().then(() => {
        this.checkLoginStatues?.(); 
      });
    }
  }  

}
